import { URL_QANTY } from '@/constants/api-constants';
import { ITicketQanty } from '@/interfaces/qanty';
import { axiosInstance } from './axios-instance';

export const getShiftBranches = async () => {
    return axiosInstance.get(`${URL_QANTY}/get_branches`);
};

export const getShiftService = async ({ branchId }) => {
    return axiosInstance.get(`${URL_QANTY}/get_lines/${branchId}`);
};

export const createShift = async (payload: ITicketQanty) => {
    return axiosInstance.post(`${URL_QANTY}/create_ticket`, payload);
};

export const getTicketShift = async (ticketId: string) => {
    return axiosInstance.get(`${URL_QANTY}/get_ticket/${ticketId}`);
};

export const cancelTicketShift = async (ticketId: string) => {
    return axiosInstance.put(
        `${URL_QANTY}/cancel_ticket/${ticketId}`,
        undefined
    );
};
